import * as React from 'react';
import { useIntl } from 'react-intl';
import { JRCFormCheckbox } from '../JRCFormCheckbox/JRCFormCheckbox';

export type JRCFormSendAlertInputProps = React.ComponentPropsWithoutRef<'input'>;

/**
 * @deprecated Create or use a JRCInput alternative compatible with react-hook-form instead
 */
export const JRCFormSendAlertField = (props: { name: string }) => {
    const intl = useIntl();
    return (
        <JRCFormCheckbox
            checkboxMode="toggle"
            name={props.name}
            options={[
                {
                    label: intl.formatMessage({ id: 'GLOBAL_Form_SendAlert' }),
                    value: 'YES',
                },
            ]}
            reduxFormValueType="boolean"
        />
    );
};
